import React from 'react';
import PageLayout from '../../layouts/pagelayout';
import SectionTitle from '../../components/section-title';
import CustomImage from '../../components/custom-image';
import BreadCrumb from '../../components/breadcrumb';
import Accordion from '../../components/accordion';
import WorkforceSafety from '../../content/materiality-assessment/workforce-safety';
import EnvironmentManagement from '../../content/materiality-assessment/environment-management';
import LicenseToUpdate from '../../content/materiality-assessment/license-to-update';
import PeopleDiversity from '../../content/materiality-assessment/people-diversity';
import HealthSafety from '../../content/materiality-assessment/materialiy-assessment-mobile/health-safety';
import WaterManagement from '../../content/materiality-assessment/materialiy-assessment-mobile/water-management';
import EnergyClimateChange from '../../content/materiality-assessment/materialiy-assessment-mobile/energy-climate-change';
import SolidWaste from '../../content/materiality-assessment/materialiy-assessment-mobile/solid-waste';
import TailingDam from '../../content/materiality-assessment/materialiy-assessment-mobile/taling-dam';
import Biodiversity from '../../content/materiality-assessment/materialiy-assessment-mobile/biodiversity';
import CommunityDevelopment from '../../content/materiality-assessment/materialiy-assessment-mobile/community-development';
import GrievanceManagement from '../../content/materiality-assessment/materialiy-assessment-mobile/grievance-management';
import SupplyChain from '../../content/materiality-assessment/materialiy-assessment-mobile/supply-chain';
import UploadingRights from '../../content/materiality-assessment/materialiy-assessment-mobile/upholding-rights';
import EthicalBusiness from '../../content/materiality-assessment/materialiy-assessment-mobile/ethical-business';
import DiversityEqualOpertunities from '../../content/materiality-assessment/materialiy-assessment-mobile/diversity-equal-opertunities';

import ScrollPositionAnimation from '../../components/scrollpositionanimation';

const MaterialityAssesement = () => {
  const MaterialityAssesementData = {
    accordion: [
      { id: 1, title: 'Workforce Safety', source: () => <WorkforceSafety /> },
      { id: 2, title: 'Environment Management', source: () => <EnvironmentManagement /> },
      { id: 3, title: 'Securing our social license to operate', source: () => <LicenseToUpdate /> },
      { id: 4, title: 'People and Diversity', source: () => <PeopleDiversity /> },
    ],
    workforce: [{ id: 1, title: 'Health & Safety', source: () => <HealthSafety /> }],
    environment: [
      { id: 1, title: 'Water Management', source: () => <WaterManagement /> },
      { id: 2, title: 'Energy & Climate Change', source: () => <EnergyClimateChange /> },
      { id: 3, title: 'Solid Waste Management', source: () => <SolidWaste /> },
      { id: 4, title: 'Tailings Dam Management', source: () => <TailingDam /> },
      { id: 5, title: 'Biodiversity', source: () => <Biodiversity /> },
    ],
    securingoursocial: [
      { id: 1, title: 'Community Development', source: () => <CommunityDevelopment /> },
      { id: 2, title: 'Grievance Management', source: () => <GrievanceManagement /> },
      { id: 3, title: 'Supply Chain Sustainability', source: () => <SupplyChain /> },
      { id: 4, title: 'Upholding Rights of Indigenous People', source: () => <UploadingRights /> },
    ],
    peoplediversity: [
      { id: 1, title: 'Ethical Business Practices', source: () => <EthicalBusiness /> },
      { id: 2, title: 'Diversity & Equal Opportunity', source: () => <DiversityEqualOpertunities /> },
    ],
  };
  return (
    <PageLayout pageTitle="Vedanta - Materiality Assessment" pageLink="/sustainability-and-esg/materiality-assessment">
      <div className="materiality-assessment-section top-section">
        <div className="materiality-assessment-container left-img-content">
          <BreadCrumb />
          <div className="section-inner">
            <ScrollPositionAnimation targetElement1="anim-one" targetElement2="anim-two">
              <div className="two-column">
                <div className="media">
                  <div className="left-to-right anim-one">
                    <div className="desktop-img">
                      <CustomImage
                        className="custom-image"
                        imageName="materiality-assessment.jpg"
                        alt="Materiality assessment"
                        maxWidth="635"
                      />
                    </div>
                    <div className="mobile-img">
                      <CustomImage
                        className="custom-image"
                        imageName="materiality-assessment-mobile.jpg"
                        alt="Materiality assessment"
                        maxWidth="768"
                      />
                    </div>
                  </div>
                </div>
                <div className="content">
                  <div className="bottom-to-top anim-two">
                    <SectionTitle
                      label="MATERIALITY ASSESSMENT"
                      lighttext="DELIVERING ON"
                      iconimage="materiality-assessment-icon.png"
                      boldtext="ESG PRIORITIES"
                    ></SectionTitle>
                    <p>
                      In addition to the normal course of engagement, overseen by respective BUs and functions of the
                      business, Vedanta, conducts a formal stakeholder engagement and materiality assessment exercise,
                      once in every three years. This exercise is conducted to ensure that we have accounted for all
                      expectations or concerns conveyed to us by our stakeholders, especially with regard to
                      sustainability performance.{' '}
                    </p>
                    <p>
                      During FY2020, we completed our largest such exercise, having interacted with nearly 2,900
                      internal and external stakeholders via online surveys, focus group discussions, and face-to-face
                      interactions. The results of this exercise have been distilled by our senior leadership team into
                      areas that require our immediate attention and intervention (High); areas that can be managed
                      using our existing frameworks and protocols (Medium); and areas that need continuous monitoring to
                      prevent them from becoming critical for the organisation over time (Low). Classification of the
                      areas was done using the following framework: (i) Importance to external stakeholders; (ii)
                      Importance to the Vedanta leadership team; (iii) Potential regulatory impact; (iv) Potential
                      reputational impact; and (v) Potential financial impact.
                    </p>
                  </div>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>
        <div className="materiality-assessment-container esg-section">
          <div className="section-inner">
            <ScrollPositionAnimation targetElement2="anim-three">
              <div className="bottom-to-top anim-three">
                <div className="esg-content-row">
                  <div className="content">
                    <p>
                      These results are specific to ESG-related expectations from the Company and do not include aspects
                      related to economic/financial expectations.
                    </p>
                  </div>
                  <div className="esg-table-wrapper">
                    <div className="tabel-wrapper">
                      <div className="table desktop-img">
                        <CustomImage
                          className="custom-image"
                          imageName="esg-economic-expection.png"
                          alt="ESG-related expectations"
                          maxWidth="999"
                        />
                      </div>
                      <div className="table mobile-img">
                        <CustomImage
                          className="custom-image"
                          imageName="esg-economic-expection-mobile.png"
                          alt="ESG-related expectations"
                          maxWidth="999"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>
        <div className="materiality-assessment-container accordion-container">
          <div className="section-inner">
            <ScrollPositionAnimation targetElement2="anim-four">
              <div className="bottom-to-top anim-four">
                <div className="esg-content-row">
                  <div className="two-column">
                    <div className="content">
                      <p>
                        We further analysed the areas with ‘high’ expectations to explore how they are integrated with
                        the UN Sustainable Development Goals. The final set of actions and targets, in alignment with UN
                        SDGs, are described in the table below:
                      </p>
                    </div>
                    <div className="goals-graph desktop-img">
                      <CustomImage
                        className="custom-image"
                        imageName="targets-actions.png"
                        alt="Sustainable dvelopment goals"
                        maxWidth="438"
                      />
                    </div>
                    <div className="goals-graph mobile-img">
                      <CustomImage
                        className="custom-image"
                        imageName="targets-actions-mobile.png"
                        alt="Sustainable dvelopment goals"
                        maxWidth="438"
                      />
                    </div>
                  </div>
                  <div className="accordion-innner desktop-accordion">
                    <Accordion data={MaterialityAssesementData.accordion} />
                  </div>
                  <div className="accordion-innner mobile-accordion">
                    <div className="accordion-row-sm">
                      <h6>The safety of our workforce</h6>
                      <p className="subtitle">Issues Emerging as ‘High’ Priority</p>
                      <Accordion data={MaterialityAssesementData.workforce} />
                    </div>
                    <div className="accordion-row-sm">
                      <h6>Environment Management</h6>
                      <p className="subtitle">Issues Emerging as ‘High’ Priority</p>
                      <Accordion data={MaterialityAssesementData.environment} />
                    </div>
                    <div className="accordion-row-sm">
                      <h6>Securing our social license to operate</h6>
                      <p className="subtitle">Issues Emerging as ‘High’ Priority</p>
                      <Accordion data={MaterialityAssesementData.securingoursocial} />
                    </div>
                    <div className="accordion-row-sm">
                      <h6>People and Diversity</h6>
                      <p className="subtitle">Issues Emerging as ‘High’ Priority</p>
                      <Accordion data={MaterialityAssesementData.peoplediversity} />
                    </div>
                  </div>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default MaterialityAssesement;
